import React, { FC } from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { GenericErrorMessage } from 'components/common/generic-error-message';

const ErrorPage: FC = () => (
  <UitkLayoutFlex alignItems="center" justifyContent="center" className="height-full">
    <UitkLayoutFlexItem>
      <GenericErrorMessage />
    </UitkLayoutFlexItem>
  </UitkLayoutFlex>
);

export default ErrorPage;
